import $ from "jquery";

let i18 = {
    "pl": {
        "Settings updated": "Ustawienia zmienione"
    }
}

function t(message) {
    if (lang === "en") return message;
    if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
}

let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

var GPPYUpdateNotifications = {
    init: function() {
        $('.updateNotifications input').on('change', GPPYUpdateNotifications.updateNotifications)
    },

    updateNotifications: function() {
        var marketing = $('.updateNotifications input').is(':checked')?1:0
        $('.updateNotificationsErrors').html('').addClass("hidden");
        Promise.resolve($.post('/api/changeMarketingPermission/', {
            'marketing' : marketing
        })).then(
            GPPYUpdateNotifications.changed)

    },

    changed: function() {
        $('.updateNotificationsErrors').html(t("Settings updated")).removeClass("hidden").removeClass("has-error");
    }
}

$('document').ready(GPPYUpdateNotifications.init);

